<template>
  <div>
    <stepper-content-card
      @skipStep="$emit('skipStep')"
      @changeStep="handleStepChange()"
      :dataLoading="dataLoading"
      :step="1"
      :hideCoverImg="true"
      imgUrl="https://images.unsplash.com/photo-1483691278019-cb7253bee49f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    >
      <div slot="cover">
        <div id="map" style="width: 100%; height: 300px"></div>
      </div>
      <div slot="heading">Location</div>
      <div slot="subheading">Where you currently reside?</div>
      <div slot="body" class="mt-3">
        <!-- <v-text-field
          v-show="currentAddressSet" 
          dense 
          readonly 
          hide-details
          outlined
          label="Map Location" 
          :value="currentAddress" 
           /> -->
        <v-text-field
          :loading="currentAddressLoading"
          name="field1"
          outlined
          label="Search for a location"
          placeholder="Area, street name ..."
          id="autocomplete"
          v-model="searchText"
          hide-details
          dense
        ></v-text-field>
        <div class="mt-2 d-flex align-center">
          <h3 class="body-2">Current Location:</h3>
          <v-btn color="ml-4" small depressed @click="getLocation">
            <v-icon small left>mdi-crosshairs-gps</v-icon>
            AUTO DETECT</v-btn
          >
        </div>
        <div class="mt-4">
          <v-text-field
            v-model="houseAddress"
            dense
            outlined
            label="House/Flat/Block No"
          >
          </v-text-field>
        </div>
      </div>
    </stepper-content-card>
  </div>
</template>

<script>
import StepperContentCard from "./StepperContentCard";
import cloneDeep from "lodash/cloneDeep";
import isEqual from 'lodash/isEqual'
import round from 'lodash/round'

export default {
  props: ["currentPerson", "dataLoading"],
  data() {
    return {
      houseAddress: "",
      searchText: "",
      currentAddress: "",
      map: null,
      marker: null,
      showMapDialog: false,
      currentAddressSet: false,
      mapLocation: null,
      latLngStr: "",
      latLngObj: {
        lat: null,
        lng: null
      },
      triggerPollMarkerLocation: true,
      currentAddressLoading: false
    };
  },
  mounted() {

    let { mapAddress, mapLocation, houseAddress } = cloneDeep(
      this.currentPerson
    );
    [this.searchText, this.houseAddress, this.currentAddress] = [
      mapAddress,
      houseAddress,
      mapAddress,
    ];

    this.initGoogleMap();
    this.initPlacesAutocomplete();
    !!this.currentAddress
      ? this.setLocation(mapLocation.lat, mapLocation.lng)
      : undefined;
  },
  methods: {
    initGoogleMap() {
      const self = this;

      var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 17,
        center: new google.maps.LatLng(26.13564, 91.80069),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        scaleControl: true,
        zoomControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

      this.map = map;

      var marker = new google.maps.Marker({
        map: map,
        // draggable: true,
        draggable: false,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(26.13564, 91.80069),
      });

      this.marker = marker;

      google.maps.event.addListener(map, "drag", function () {
        marker.setPosition(map.getCenter());
        if (self.triggerPollMarkerLocation) {
          self.triggerPollMarkerLocation = false;
          self.pollMarkerLocation();
        }
      });
    },
    async pollMarkerLocation() {
      this.currentAddressLoading = true
      var oldVal = { lat: this.getLat(), lng: this.getLng() }
      
      var intervalFn = setInterval(() => {
        var newVal = { lat: this.getLat(), lng: this.getLng() }
        
        if(!isEqual(oldVal, newVal)) {
          this.getMapAddress(newVal.lat, newVal.lng)
          oldVal = cloneDeep(newVal)
        } else {
          this.triggerPollMarkerLocation = true
          this.currentAddressLoading = false
          clearInterval(intervalFn)
        }
      }, 700)
    },
    getLat() {
      return round(this.marker.getPosition().lat(), 5)
    },
    getLng() {
      return round(this.marker.getPosition().lng(), 5)
    },
    initPlacesAutocomplete() {
      const self = this;

      let autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        {
          bounds: new google.maps.LatLngBounds(
            new google.maps.LatLng(20.593684, 78.96288)
          ),
        }
      );

      google.maps.event.addListener(autocomplete, "place_changed", function () {
        // infowindow.close();
        var place = autocomplete.getPlace();
        var location = place.geometry.location;
        self.map.setCenter(location);
        self.marker.setPosition(location);
        self.mapLocation = {
          lat: location.lat(),
          lng: location.lng(),
        };
      });
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.onLocationSelect);
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },
    setLocation(lat, lng) {
      var latlng = this.getLatLng(lat, lng);
      this.map.setCenter(latlng);
      this.marker.setPosition(latlng);
      this.mapLocation = { lat, lng };
      return latlng;
    },
    onLocationSelect(position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      this.setLocation(lat, lng);
      this.getMapAddress(lat, lng);
    },
    getLatLng(lat,lng) {
      return new google.maps.LatLng(lat,lng)
    },
    getMapAddress(lat, lng) {
      const self = this;
      var latlng = this.getLatLng(lat, lng)

      new google.maps.Geocoder().geocode(
        {
          latLng: latlng,
        },
        function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
              self.currentAddress = results[1].formatted_address;
              self.searchText = self.currentAddress;
              self.mapLocation = { lat, lng };
              return self.currentAddress
            } else {
              alert("No results found");
            }
          } else {
            alert("Geocoder failed due to: " + status);
          }
        }
      );
    },
    handleStepChange() {
      this.$emit("changeStep", {
        mapLocation: this.mapLocation,
        houseAddress: this.houseAddress,
        mapAddress: this.currentAddress,
      });
    },
  },
  components: {
    StepperContentCard,
  },
};
</script>

<style>
.pac-item {
  padding: 5pxpx;
  font-size: 14px;
  cursor: pointer;
}

.pac-item:hover {
  background-color: #ececec;
}
</style>